import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["birthdate", "zodiacDisplay", "personaCard", "personaInput"]

  static values = {
    zodiacUrls: Object,
    upgradeUrl: String
  }

  connect() {
    if (this.hasBirthdateTarget && this.birthdateTarget.value) {
      this.updateZodiacDisplay()
    }
  }

  birthdateChanged() {
    this.updateZodiacDisplay()
  }

  updateZodiacDisplay() {
    if (!this.hasZodiacDisplayTarget) return

    const value = this.birthdateTarget?.value
    if (!value) {
      this.zodiacDisplayTarget.innerHTML = ""
      this.zodiacDisplayTarget.classList.add("hidden")
      return
    }

    const slug = this.zodiacFromDate(value)
    if (!slug) {
      this.zodiacDisplayTarget.innerHTML = ""
      this.zodiacDisplayTarget.classList.add("hidden")
      return
    }

    const urls = this.zodiacUrlsValue || {}
    const src = urls[slug] || `/assets/zodiac/${slug}.svg`
    const label = slug.charAt(0).toUpperCase() + slug.slice(1)
    const img = document.createElement("img")
    img.src = src
    img.alt = slug
    img.className = "w-16 h-16 md:w-20 md:h-20 object-contain"
    const span = document.createElement("span")
    span.className = "text-gold font-semibold"
    span.textContent = label
    this.zodiacDisplayTarget.innerHTML = ""
    this.zodiacDisplayTarget.appendChild(img)
    this.zodiacDisplayTarget.appendChild(span)
    this.zodiacDisplayTarget.classList.remove("hidden")
  }

  zodiacFromDate(dateStr) {
    const parts = dateStr.split("-")
    if (parts.length < 3) return null
    const month = parseInt(parts[1], 10)
    const day = parseInt(parts[2], 10)
    if (isNaN(month) || isNaN(day)) return null

    const ranges = {
      1: { 19: "capricorn", 31: "aquarius" },
      2: { 18: "aquarius", 29: "pisces" },
      3: { 20: "pisces", 31: "aries" },
      4: { 19: "aries", 30: "taurus" },
      5: { 20: "taurus", 31: "gemini" },
      6: { 20: "gemini", 30: "cancer" },
      7: { 22: "cancer", 31: "leo" },
      8: { 22: "leo", 31: "virgo" },
      9: { 22: "virgo", 30: "libra" },
      10: { 22: "libra", 31: "scorpio" },
      11: { 21: "scorpio", 30: "sagittarius" },
      12: { 21: "sagittarius", 31: "capricorn" }
    }

    const monthRanges = ranges[month]
    if (!monthRanges) return null

    const keys = Object.keys(monthRanges).map(Number).sort((a, b) => a - b)
    for (const cutoff of keys) {
      if (day <= cutoff) return monthRanges[cutoff]
    }
    return null
  }

  selectPersona(event) {
    const card = event.currentTarget
    const free = card.dataset.free === "true"
    const id = card.dataset.personaId

    if (free && id) {
      this.personaCardTargets.forEach(c => c.classList.remove("border-gold", "ring-2", "ring-gold"))
      card.classList.add("border-gold", "ring-2", "ring-gold")
      this.personaInputTarget.value = id
    } else if (this.hasUpgradeUrlValue && this.upgradeUrlValue) {
      Turbo.visit(this.upgradeUrlValue, { frame: "modal" })
    }
  }
}
